/**
 * Exposes the PostHog client (when configured) so useAnalytics can send events to both Mixpanel and PostHog
 * without calling usePostHog() when the provider is not mounted.
 */

import { createContext, useContext } from 'react'

export interface PostHogClientLike {
  capture: (event: string, properties?: Record<string, unknown>) => void
  identify: (distinctId: string, properties?: Record<string, unknown>) => void
  reset: () => void
  screen?: (name: string, properties?: Record<string, unknown>) => void
}

export const PostHogClientContext = createContext<PostHogClientLike | null>(null)

export function usePostHogClient(): PostHogClientLike | null {
  return useContext(PostHogClientContext)
}
